<template>
  <v-app id="inspire" class=" tw-bg-white">
    <r-f-q-nav v-if="isAuthenticated" />

    <div class="image tw-h-full lg:tw-h-full">
      <div class="tw-w-full tw-flex tw-items-center tw-px-2 lg:tw-px-4 ">
        <v-col class="tw-h-auto md:tw-h-auto mx-auto" cols="12" sm="12" md="5">
          <v-card flat class="overlay tw-p-2 md:tw-p-6">
            <div v-if="isAuthenticated">
              <div class="tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-mt-20 lg:tw-mt-0">
                <div class="tw-w-full tw-flex tw-justify-center">
                  <img class="tw-h-20 tw-w-auto tw-mb-10 lg:tw-mb-12" src="/logo.jpg" alt="Workflow logo">
                </div>
                <div class="tw-w-full tw-flex tw-items-center tw-justify-center">
<!--                  <img class="tw-w-24" src="/images/ellipses.jpg"  alt="smiley">-->
                  <div class="tw-px-2 md:tw-px-5 c-blue-text">
                    <h1 class="c-navy-text tw-text-2xl md:tw-text-3xl tw-font-medium">Welcome Back {{authenticatedUser.name.split(' ')[0] || authenticatedUser.name}}</h1>
                    <p class="c-blue-text">Here is a quick menu to get things done</p>
                  </div>
                </div>
                <div class="tw-flex tw-w-full md:tw-w-11/12 2xl:tw-w-9/12 tw-justify-center tw-mt-5 md:tw-mt-12 tw-grid tw-grid-cols-2 md:tw-grid-cols-2 tw-text-center">
                  <router-link id="dashboard" :to="{ name: 'Dashboard' }" class="tw-flex tw-flex-col tw-justify-center tw-mx-4">
                    <v-icon color="primary" size="60" alt="car">mdi-apps</v-icon>
                    <div class="c-navy-text">Dashboard <v-icon color="primary">mdi-chevron-right</v-icon></div>
                  </router-link>
                  <router-link id="quotes" :to="{ name: 'SavedQuotes' }" class="tw-flex tw-flex-col tw-justify-center tw-mx-4">
                    <v-icon color="primary" size="60" alt="car">mdi-shield-edit</v-icon>
                    <div class="c-navy-text">Resume Quote <v-icon color="primary">mdi-chevron-right</v-icon></div>
                  </router-link>
                  <router-link id="policies" :to="{ name: 'MyPolicies' }" class="tw-flex tw-flex-col tw-justify-center tw-mx-4 tw-mt-4 md:tw-mt-8">
                    <v-icon color="primary" size="60" alt="car">mdi-shield-car</v-icon>
                    <div class="c-navy-text">My Policies <v-icon color="primary">mdi-chevron-right</v-icon></div>
                  </router-link>
                  <!-- <a id="claim" href="" target="_blank" rel="noopener noreferrer" class="tw-flex tw-flex-col tw-justify-center tw-mx-4 tw-mt-4 md:tw-mt-8">
                    <v-icon color="primary" size="60" alt="car">mdi-shield-lock</v-icon>
                    <div class="c-navy-text">Report Claim <v-icon color="primary">mdi-chevron-right</v-icon></div>
                  </a> -->
                  <router-link id="claims" :to="{ name: 'Claims' }" class="tw-flex tw-flex-col tw-justify-center tw-mx-4 tw-mt-4 md:tw-mt-8">
                    <v-icon color="primary" size="60" alt="car">mdi-shield-car</v-icon>
                    <div class="c-navy-text">Report Claim <v-icon color="primary">mdi-chevron-right</v-icon></div>
                  </router-link>
                </div>
              </div>
            </div>
            <div v-else class="tw-w-full tw-flex flex-wrap tw-justify-center tw-mt-10 lg:tw-mt-0">
              <div class="tw-w-full tw-flex tw-justify-center">
                <img class="tw-h-20 tw-w-auto tw-mb-10 lg:tw-mb-12" src="/logo.jpg" alt="Workflow logo">
              </div>
              <div class="tw-w-11/12 xl:tw-w-11/12 tw-text-center tw-flex flex-wrap tw-justify-center">
                <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-text-left">
<!--                  <img class="tw-w-24" src="/images/ellipses.jpg"  alt="smiley">-->
                  <div class="tw-px-2 md:tw-px-5 tw-text-center">
                    <h1 class="tw-font-bold  c-white-text tw-text-xl md:tw-text-3xl tw-font-medium">Convenience at the click of a button.</h1>
                    <p class="c-blue-text">Buy, Renew and Claim For Comfort & Peace in Life.</p>
                  </div>
                </div>
                <div class="tw-w-full md:tw-w-10/12 tw-mt-6">
                  <v-btn id="request-for-quote" :to="{name: 'Request'}" block large color="secondary" class="my-3 white--text tw-w-full animate-bounce">Get Quotation</v-btn>

                  <div class="tw-w-full tw-flex tw-my-5 lg:tw-my-8 tw-items-center c-navy-text">
                    <div class="tw-w-5/12">
                      <hr>
                    </div>
                    <div class="tw-w-2/12 c-navy-text">
                      OR
                    </div>
                    <div class="tw-w-5/12">
                      <hr>
                    </div>
                  </div>

                  <div class="tw-w-full tw-flex tw-grid tw-grid-cols-2 tw-gap-2">
                    <v-btn color="primary" :to="{name: 'SignIn'}">
                      Sign In
                    </v-btn>
                    <v-btn color="primary" :to="{name: 'SignUp'}">
                      Sign Up
                    </v-btn>
                  </div>

                  <!-- <div v-if="show" class="tw-w-full tw-mt-4 md:tw-mt-10 tw-text-left c-blue-text tw-flex tw-items-center">
                    <a id="playstore-link" class="" href="https://play.google.com/store/apps/details?id=ke.co.apollo.client.app" target="_blank" rel="noopener"><img src="/images/google-play-badge.png" alt="play store"></a>
                    <p class="tw-text-xs md:tw-text-sm md:tw-text-left tw-px-2  tw-mt-3">You can also download our Motor Happiness App on the Google play store</p>
                  </div> -->
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </div>
    </div>

  </v-app>
</template>

<script>
import RFQNav from '@/components/layout/partials/RFQNav';
import { mapGetters } from 'vuex';

export default {
  name: 'Landing',
  components: { RFQNav },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'authenticatedUser']),
  },
};
</script>

<style lang="scss" scoped>
.image {
  background-image: url('/images/bg.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.overlay {
  background: rgba(39,62,84,0.62);
  overflow: hidden;
  height: 100%;
  z-index: 2;
}
.animate-bounce {
  animation: bounce 1s infinite
};

@keyframes bounce {
  0%, 100% {
    transform: translateY(55%);
    animationTimingFunction: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(10%);
    animationTimingFunction: cubic-bezier(.5, 0, 0.2, 1);
  }
}
</style>
